import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchAdmins = ({ accountId }) => get(`/accounts/${accountId}/admins`);

export const addAdmin = ({ accountId, admin }) => post(`/accounts/${accountId}/admins`, admin);

export const fetchAccountAdminconfig = ({ accountId, adminId }) => get(`/accounts/${accountId}/admins/${adminId}`);

export const updateAccountAdminConfig = ({ accountId, adminId, ...params }) =>
  patch(`/accounts/${accountId}/admins/${adminId}/config`, params);

export const updateAdmin = ({ accountId, adminId, admin }) => patch(`/accounts/${accountId}/admins/${adminId}`, admin);

export const deleteAdmin = ({ accountId, adminId }) => httpDelete(`/accounts/${accountId}/admins/${adminId}`);

export const resendAdminEmail = ({ accountId, adminId }) => post(`/accounts/${accountId}/admins/${adminId}/invite`);
